import React from 'react';
import { ImageIcon, CalendarIcon, SmartphoneIcon, GiftIcon } from 'lucide-react';
export const Bonuses: React.FC = () => {
  const bonuses = [{
    icon: <ImageIcon className="w-8 h-8" data-id="element-20" />,
    title: 'Disciplina y Grandeza en 4K',
    description: 'Listo para imprimir o usar como fondo de escritorio. Una obra de arte minimalista que captura la esencia de un campeón.'
  }, {
    icon: <CalendarIcon className="w-8 h-8" data-id="element-21" />,
    title: 'Plantilla Rutina 110%',
    description: 'Aplica su mentalidad día a día con esta plantilla exclusiva para organizar tus objetivos y hábitos como un verdadero profesional.'
  }, {
    icon: <SmartphoneIcon className="w-8 h-8" data-id="element-22" />,
    title: 'Pack Exclusivo Wallpapers',
    description: 'Visualiza tu inspiración cada vez que desbloqueas tu pantalla con estos diseños exclusivos en alta resolución.'
  }];
  return <section className="py-20" data-id="element-23">
      <div className="text-center mb-16" data-id="element-24">
        <div className="inline-flex items-center justify-center p-2 bg-black border border-yellow-600/30 rounded-full mb-6" data-id="element-25">
          <div className="px-4 py-1 bg-gradient-to-r from-yellow-600/20 to-yellow-800/20 text-yellow-500 text-sm font-medium rounded-full" data-id="element-26">
            BONOS EXCLUSIVOS
          </div>
        </div>
        <h2 className="text-3xl md:text-4xl font-bold mb-6 flex items-center justify-center" data-id="element-27">
          <GiftIcon className="w-8 h-8 text-yellow-500 mr-2" data-id="element-28" /> BONOS ESPECIALES
        </h2>
        <p className="text-lg text-gray-300 max-w-3xl mx-auto" data-id="element-29">
          Además del ebook coleccionable, recibirás estos bonos exclusivos para
          maximizar tu experiencia.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-30">
        {bonuses.map((bonus, index) => <div key={index} className="p-6 bg-gradient-to-b from-gray-900 to-black border border-yellow-600/20 rounded-xl hover:border-yellow-600/50 transition-all duration-300" data-id="element-31">
            <div className="w-16 h-16 bg-black/50 rounded-full flex items-center justify-center mb-6 border border-yellow-600/30 text-yellow-500" data-id="element-32">
              {bonus.icon}
            </div>
            <h3 className="text-xl font-bold mb-4" data-id="element-33">{bonus.title}</h3>
            <p className="text-gray-400" data-id="element-34">{bonus.description}</p>
          </div>)}
      </div>
      <div className="mt-12 p-6 border border-dashed border-yellow-600/40 rounded-lg bg-yellow-600/5" data-id="element-35">
        <div className="flex flex-col items-center" data-id="element-36">
          <div className="w-full text-center" data-id="element-37">
            <h3 className="text-xl font-bold mb-2" data-id="element-38">
              Imagina una semana después...
            </h3>
            <p className="text-gray-300" data-id="element-39">
              Empiezas a aplicar su rutina mental cada mañana. Te recuerdas que
              el esfuerzo no es castigo, es identidad.
            </p>
            <p className="text-gray-300 mt-4" data-id="element-40">
              Alguien te pregunta: — "¿Qué estás haciendo diferente?"
            </p>
            <p className="text-gray-300 mt-4" data-id="element-41">
              Tú solo sonríes. Y miras esa pieza digital que pocos tienen.
              Porque algo cambió. Y lo sientes. Aunque aún no puedas explicarlo.
            </p>
          </div>
        </div>
      </div>
    </section>;
};